import { render, staticRenderFns } from "./name-reexamine.vue?vue&type=template&id=4f368b01&scoped=true"
import script from "./name-reexamine.vue?vue&type=script&lang=js"
export * from "./name-reexamine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f368b01",
  null
  
)

export default component.exports